module.exports = __webpack_public_path__ + "static/media/avatars_female_2.e91a67d0.png";